@if(!hasResult) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if(hasResult) {
  @if(forceDialog || showDownload) {
    <dialog-hint [clickTarget]='idTargetElement' class="pdf-callout" [textkey]="textkeyPrefix + '.callout' | translate" [closable]="true"></dialog-hint>
  }
  <div class="grid-x grid-margin-x headline-wrapper" #analyseWrapper>
    <div class="cell small-12 large-offset-1 large-10 text-center">
      <h1 [innerHTML]="textkeyPrefix + '.verbrauchsanalyse.headline' | translate"></h1>
      <app-ergebnis-analyse [anfrage]="anfrage" [textPlaceholder]="textPlaceholder"></app-ergebnis-analyse>
    </div>
  </div>

  @if(textPlaceholder?.costs_euro_year > 0 || textPlaceholder?.costs_euro_year.includes('-')) {
    <app-kosten-sparpotenzial [internalPortal]="internalPortal" [textPlaceholder]="textPlaceholder" [textkeyPrefix]="'warmwassercheck.ergebnis.kosten'" [imagePath]="'/wwc/wwc-kosten.svg'" [savingsEuroYear]="textPlaceholder?.savings_euro_year" [stage]="textPlaceholder?.stage"></app-kosten-sparpotenzial>
  }

  @if (textPlaceholder?.savings_euro_year > 0 || textPlaceholder?.savings_euro_year.includes('-')) {
    <section class="climate">
      <h2 [innerHTML]="textkeyPrefix + '.klima.headline' | translate"></h2>

      <div class="grid-x grid-padding-x">
        @for (type of ['jaehrlich', 'ausgleich_baeume']; track type) {
          <div class="cell small-6">
            <div class="co2 {{type}}">
              <span [innerHTML]="textkeyPrefix + '.klima.' + type | translate"></span>
              <strong>{{ textPlaceholder['co2_' + type] }}
                @if (type !== 'ausgleich_baeume') {
                  {{ 'unit.' + (textPlaceholder?.co2_jaehrlich_plain < 1 ? 'kg' : 't') | translate }}
                }
              </strong>
            </div>
          </div>
        }
      </div>
    </section>
  }

  @if (textPlaceholder?.reduce_consumption) {
    <section class="reduce-consumption-section">
      <h2 [innerHTML]="textkeyPrefix + '.reduce.headline' | translate"></h2>
      <div class="reduce-consumption">
        @if (textPlaceholder.current_stage === 'A') {
          <strong class="current-stage stage-{{ textPlaceholder.stage }}">{{ textPlaceholder.current_stage }}</strong>
        }
        @else {
          <div class="reduce current-stage stage-{{ textPlaceholder.stage }}">
            <i class="icon-arrow-down"></i>
            <strong [innerHTML]="(textkeyPrefix + '.reduce.consumption_better_stage') | translate: textPlaceholder | safeHtml"></strong>
          </div>
        }
        <div class="reduce-text">
          <p [innerHTML]="textkeyPrefix + '.reduce.' + textPlaceholder.reduce_consumption | translate"></p>
          @if (internalPortal) {
            <span [innerHTML]="textkeyPrefix + '.reduce.challenge.hint' | translate"></span>
          }
        </div>
      </div>
    </section>
  }

  @if (internalPortal && forceDialog) {
    <div class="grid-x grid-margin-x">
      <div class="cell small-12 medium-8">
        <div class="nextsteps-wrapper" [class.internal]="internalPortal">
          <h2 [innerHTML]="textkeyPrefix + '.nextsteps.headline' | translate"></h2>
          <p [innerHTML]="textkeyPrefix + '.nextsteps.teaser' | translate"></p>
        </div>
      </div>
    </div>
  }

  @if(forceDialog) {
    <app-dialogform [id]="idTargetElement" textkeyPrefix="warmwassercheck" advisorImagePath="/wwc/pdf-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" [downloadUrl]="reportUrl"></app-dialogform>
  }
  @if(replacementPlaceholder && replacementPlaceholder[0].amount > 0) {
    <section class="replacement">
      <h2 [innerHTML]="textkeyPrefix + '.replacement.headline' | translate"></h2>
      <p [innerHTML]="textkeyPrefix + '.replacement.subheadline' | translate"></p>

      <div class="accordion-wrapper">
        <mat-accordion multi="true" displayMode="flat" class="replace">
          @for (placeholder of replacementPlaceholder; track placeholder.name) {
            @if (placeholder.amount > 0) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <i [class]="'icon-' + placeholder.icon"></i>
                    <div class="headline-amount">
                      <div [innerHTML]="textkeyPrefix + '.replace.' + placeholder.name + '.headline' | translate"></div>
                      @if (placeholder.name.includes('_')) {
                        <strong>{{ placeholder.amount }} {{(placeholder.unit ? 'unit.' + placeholder.unit : '') | translate}} {{ ('unit.' + placeholder.name.split('_')[0]) | translate }}</strong>
                      }
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                  <span [innerHTML]="(textkeyPrefix + '.replace.' + placeholder.name + '.text.' + placeholder.type) | translate"></span>
                  @if(anfrage?.userInput?.nutzungstyp === WarmwassercheckConstants.NUTZUNGSTYP_MIETER && placeholder.name === 'euro_kosten') {
                    <span>{{ textkeyPrefix + '.replace.zusatz.mieter' | translate }}</span>
                  }
                </div>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </div>
    </section>
  }

  @if(textPlaceholder?.recommendations && textPlaceholder?.recommendations?.length > 0) {
    <app-ergebnis-empfehlungen [anfrage]="anfrage"></app-ergebnis-empfehlungen>
  }

  @if(hecUrl) {
    <app-advisor-teaser [url]="hecUrl" [mailUrl]="hecUrl" [textPrefix]="textkeyPrefix + '.teaser.hec'"
                        image="/wwc/hec-teaser.svg"></app-advisor-teaser>
  }

  @if(showDownload) {
    <app-download [id]="idTargetElement" [url]="reportUrl" [textkeyPrefix]="textkeyPrefix + '.'"></app-download>
  }

  <app-portal-teaser></app-portal-teaser>

  @if(internalPortal) {
    <app-donate [textkeyPrefix]="textkeyPrefix"></app-donate>
  }

  <app-step-buttons [previousLink]="previousLink" previousText="step.button.previous" [nextText]="textkeyPrefix + '.submit' | translate"
                    largeOffset="0" mediumWidthRight="auto" largeWidthRight="auto"
                    [nextLink]=null [nextSubmit]="false"></app-step-buttons>

}
